import React, { Component, useCallback } from 'react';
//import {getConfig} from '../../config.js';
import Slider from 'react-slick';

import './Carousel-base.scss';
import './Carousel.scss';

export class Carousel extends Component {

  constructor(props) {
    super(props);
    this.state = { data: {}, swiped: false };

    this._handleSwiped = this.handleSwiped.bind(this);
    this._handleOnItemClick = this.handleOnItemClick.bind(this);
  }

  componentDidMount() {
  }

  handleSwiped() {
    this.setState({swiped: true})
  }

  handleOnItemClick(e) {
    if (this.state.swiped) {
      e.stopPropagation()
      e.preventDefault()
      this.setState({swiped: false})
    }
  }

  render() {

    return (
      <Slider onSwipe={this._handleSwiped} {...this.props.settings} className={`slider--${this.props.type}`}>

        {React.Children.map(this.props.children, child => (
           <div onClickCapture={this._handleOnItemClick}>{child}</div>
         ))}
      </Slider>
    )
  }

}
